'use client'

import React, { memo, useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar } from '@fortawesome/free-solid-svg-icons'
import { format } from 'date-fns'
import Link from 'next/link'
import Image from 'next/image'

interface Props {
  imageUrl?: string
  date?: string // Dữ liệu ngày là chuỗi ISO
  title?: string
  link?: string
  isLoading?: boolean // Trạng thái loading
}

const AdsCard: React.FC<Props> = ({
  imageUrl = '',
  date = '',
  title = '',
  link = '',
  isLoading = false,
}) => {
  const [formattedDate, setFormattedDate] = useState<string | null>(null)

  useEffect(() => {
    if (date) {
      setFormattedDate(format(new Date(date), 'dd/MM/yyyy')) // Chỉ format trên client
    }
  }, [date])

  // Nếu không có imageUrl, đặt một ảnh mặc định
  const validImageUrl = imageUrl?.trim() || '/default-image.jpg'
  if (isLoading) {
    return (
      <article className="grid grid-cols-12 gap-4 border-b pb-4 mb-4 animate-pulse">
        <div className="col-span-4 bg-gray-200 rounded-md w-full h-24"></div>
        <div className="col-span-6 flex flex-col justify-between space-y-2">
          <div className="bg-gray-200 h-4 w-20 rounded"></div>
          <div className="bg-gray-200 h-6 w-36 rounded"></div>
          <div className="bg-gray-200 h-8 w-24 rounded"></div>
        </div>
      </article>
    )
  }

  return (
    <article className="grid grid-cols-12 gap-4 border-b pb-4 mb-4">
      {validImageUrl && (
        <Link
          href={`https://raovat.iamtapnews.com/${link}`}
          className="inline-block col-span-4 relative w-full h-24"
        >
          <Image
            src={`${process.env.NEXT_PUBLIC_IMAGE_URL}${validImageUrl}`}
            alt={title || 'Advertisement'}
            fill
            className="object-cover"
            priority
          />
        </Link>
      )}

      <div className="col-span-6 flex flex-col justify-between">
        {formattedDate && (
          <div className="flex items-center text-gray-500 text-sm mb-2">
            <FontAwesomeIcon icon={faCalendar} className="mr-2" />
            <span>{formattedDate}</span>
          </div>
        )}

        <h3 className="font-title font-semibold text-textGray mb-2">{title}</h3>

        <Link
          href={`https://raovat.iamtapnews.com/${link}`}
          className="w-28 bg-purple-600 text-white text-center px-3 py-1 cursor-pointer"
        >
          Chi tiết
        </Link>
      </div>
    </article>
  )
}

export default memo(AdsCard)
